// extracted by mini-css-extract-plugin
module.exports = {"card-category-view":"card-category-view__38bW5","section-sub-header":"section-sub-header__3feXo"};